// @format
import React from 'react';
import styled from 'styled-components';
import colors from '../constants/colors';
import Item from '../components/Item';

const Row = styled.div`
  display: flex;
  justify-content: stretch;
  flex-wrap: wrap;
`;

const SectionTitle = styled.div`
  width: 100%;
  color: ${colors.GRAYBLUE};
  font-size: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
`;

const Headline = styled.div`
  width: 100%;
  color: ${colors.RED};
  font-size: 24px;
  font-weight: bold;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
`;

export default () => (
  <div>
    <Row>
      <Headline>
        Reta Accountabilities and Timelines. Trustor Key Action Items and
        Deadlines.
      </Headline>
    </Row>
    <Row>
      <SectionTitle>Annual Renewal and Open Enrollment Lifecycle</SectionTitle>
    </Row>
    <Row>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.PRE-RENEWAL.pdf">
        Stage 1: Pre-Renewal
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.RENEWAL.pdf">
        Stage 2: Renewal
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.OPEN.ENROLLMENT.pdf">
        Stage 3: Open Enrollment
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.POST.ENROLLMENT.pdf">
        Stage 4: Post-Enrollment
      </Item>
    </Row>
    <Row>
      <SectionTitle>Annual Trust Management Lifecycle</SectionTitle>
    </Row>
    <Row>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.COMPLIANCE.pdf">
        Compliance
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.WELLNESS.pdf">
        Wellness
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.PHARMACY.pdf">
        Annual Pharmacy Updates
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.TR.MEETING.pdf">
        Annual Trustor Meeting
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.MANAGEMENT.pdf">
        Account Management
      </Item>
    </Row>
  </div>
);
